/* BENLING header search: the search icon opens a drop-down under the header. While someone types, the matching watches
   are fetched from Shopify's predictive search (rendered by sections/predictive-search.liquid) and each one links to its
   own product page. Without JavaScript the icon still opens the normal search page. Vanilla JS, no dependencies. */
(function () {
  'use strict';

  var cache = {};
  var timer = null;
  var controller = null;
  var lastFocus = null;

  function panel() { return document.querySelector('[data-search-panel]'); }
  function header() { return document.querySelector('[data-site-header]'); }
  function toggles() { return Array.prototype.slice.call(document.querySelectorAll('[data-search-toggle]')); }
  function isOpen() { var p = panel(); return !!p && p.classList.contains('is-open'); }

  function setup(p) {
    if (p.__bnlSearch) return;
    p.__bnlSearch = true;
    var input = p.querySelector('[data-search-input]');
    var clear = p.querySelector('[data-search-clear]');
    var results = p.querySelector('[data-search-results]');
    var start = document.createDocumentFragment();
    Array.prototype.slice.call(results.childNodes).forEach(function (n) { start.appendChild(n.cloneNode(true)); });

    function show(node) {
      results.classList.remove('is-loading');
      while (results.firstChild) results.removeChild(results.firstChild);
      results.appendChild(document.importNode(node, true));
    }

    function query(q) {
      if (cache[q]) { show(cache[q]); return; }
      if (controller) controller.abort();
      controller = typeof AbortController === 'function' ? new AbortController() : null;
      results.classList.add('is-loading');
      var url = p.getAttribute('data-url') + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&section_id=predictive-search';
      window.fetch(url, { headers: { Accept: 'text/html' }, signal: controller ? controller.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.text(); })
        .then(function (text) {
          if (input.value.trim() !== q) return; // the visitor typed on; a newer answer is coming
          var found = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-psearch-results]');
          if (!found) throw new Error('no results block');
          cache[q] = found;
          show(cache[q]);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          show(start); // search stays usable: Enter still opens the full results page
        });
    }

    function onInput() {
      var q = input.value.trim();
      clear.hidden = q === '';
      window.clearTimeout(timer);
      if (q === '') { if (controller) controller.abort(); show(start); return; }
      timer = window.setTimeout(function () { query(q); }, 180);
    }
    input.addEventListener('input', onInput);

    clear.addEventListener('click', function () { input.value = ''; onInput(); input.focus(); });
    p.querySelector('[data-search-close]').addEventListener('click', function () { close(true); });

    // arrow keys move through the matching watches
    p.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var links = Array.prototype.slice.call(results.querySelectorAll('[data-mini-link], .psearch__all'));
      if (!links.length) return;
      var i = links.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') links[Math.min(i + 1, links.length - 1)].focus();
      else if (i <= 0) input.focus();
      else links[i - 1].focus();
    });
  }

  function open() {
    var p = panel();
    if (!p) return;
    setup(p);
    lastFocus = document.activeElement;
    p.removeAttribute('inert');
    p.classList.add('is-open');
    var h = header();
    if (h) { h.classList.add('is-searching'); h.classList.remove('is-hidden'); }
    toggles().forEach(function (t) { t.setAttribute('aria-expanded', 'true'); });
    window.setTimeout(function () { var i = p.querySelector('[data-search-input]'); if (i) i.focus(); }, 60);
  }

  function close(restoreFocus) {
    var p = panel();
    if (!p || !p.classList.contains('is-open')) return;
    p.classList.remove('is-open');
    p.setAttribute('inert', '');
    var h = header();
    if (h) h.classList.remove('is-searching');
    toggles().forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    if (restoreFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  // Delegated, so the header can be re-rendered by the theme editor without losing the behaviour.
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-search-toggle]') : null;
    if (t) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      if (isOpen()) close(true); else open();
      return;
    }
    if (isOpen() && !(e.target.closest && e.target.closest('[data-search-panel]'))) close(false);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(true); });
  // moving to another page section (menu / cart) closes the drop-down
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-menu-open], [data-cart-open]')) close(false);
  });

  window.BenlingSearch = { open: open, close: close };
})();
